import type { ContactRepository } from '@src/service/worker/repository'

import { BaseService } from './base'

export class ContactService extends BaseService {
  constructor(private repo: ContactRepository) {
    super()
  }

  getUniqueSources(src: 'csv'): Promise<{ sourceName: string; userId: string }[]> {
    return this.repo.getUniqueSources().then((sources) => {
      return sources
        .filter(([source, sourceName, userId]) => src === source && sourceName && userId)
        .map(([, sourceName, userId]) => ({
          sourceName,
          userId,
        }))
    })
  }
}
